import { X } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { notify, ToastMessage } from '../../lib/notify';

import clsx from 'clsx';

export default function ToastContainer() {
  const { t: translate } = useTranslation();
  const [toasts, setToasts] = useState<ToastMessage[]>([]);

  useEffect(() => {
    const unsubscribe = notify.subscribe((msg) => {
      // System-level errors are handled via Notification Center only (no popup toast).
      if (msg.isSystemError) {
        console.log('[ToastContainer] System error hidden (notification center only):', msg.title ?? msg.description);
        return;
      }

      setToasts((prev) => [...prev, msg]);
      const timeout = setTimeout(() => {
        setToasts((prev) => prev.filter((t) => t.id !== msg.id));
      }, msg.durationMs ?? 4000);
      return () => clearTimeout(timeout);
    });
    return unsubscribe;
  }, []);

  const handleClose = (id: string) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  };

  return (
    <div className="fixed inset-0 pointer-events-none z-[10050]">
      <div className="absolute right-4 top-4 flex flex-col gap-2 w-[min(420px,calc(100vw-2rem))]">
        {toasts.map((t) => (
          <div
            key={t.id}
            className={clsx(
              'pointer-events-auto rounded-md border px-4 py-3 pr-10 shadow-md backdrop-blur-sm relative',
              'bg-background/95 text-foreground',
              {
                'border-green-600/40': t.variant === 'success',
                'border-red-600/40': t.variant === 'error',
                'border-yellow-600/40': t.variant === 'warning',
                'border-primary/40': !t.variant || t.variant === 'info',
              }
            )}
          >
            <button
              onClick={() => handleClose(t.id)}
              className="absolute top-2 right-2 p-1 rounded-md hover:bg-foreground/10 transition-colors"
              aria-label={translate('common.closeNotification')}
            >
              <X className="h-4 w-4 text-muted-foreground hover:text-foreground" />
            </button>
            {t.title && (
              <div className="font-semibold mb-0.5">
                {t.title}
              </div>
            )}
            {t.description && (
              <div className="text-sm text-muted-foreground">
                {t.description}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}


